import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DealService } from "../../services";
import { InsuranceProduct, TermCost } from "../../models";
import { HistoryService } from "../../services/history.service";

@Component({
  selector: "app-insurance-item-gap",
  templateUrl: "./insurance-item-gap.component.html",
  styleUrls: ["./insurance-item-gap.component.scss"]
})
export class InsuranceItemGapComponent implements OnInit {
  @Input() product: InsuranceProduct;
  @Input() selectedTermIndex = null;
  @Output() closeModal = new EventEmitter();

  gapForm: UntypedFormGroup = this.formBuilder.group({
    termCostIndex: [0]
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dealService: DealService,
    private historyService: HistoryService,
  ) { }

  ngOnInit() {
    this.syncSelectedPlan();
    this.gapForm.valueChanges.subscribe(({termCostIndex}) => {
      this.dealService.dealInsuranceService.submitInsuranceProduct(this.product, +termCostIndex, true);
    });
  }

  // INITIALIZATION

  syncSelectedPlan() {
    const termCostIndex = this.selectedTermIndex || 0;
    this.gapForm.patchValue({termCostIndex});
  }

  // ACTIONS

  onAcceptPlan() {
    const {termCostIndex} = this.gapForm.value;
    this.historyService.dispatchAddEvent({
      shortName: "GAP Plan Accepted",
    })
    this.dealService.dealInsuranceService.submitInsuranceProduct(this.product, +termCostIndex);
    this.closeModal.emit();
  }

  onDeclinePlan() {
    this.historyService.dispatchAddEvent({
      shortName: "GAP Plan Declined",
    })
    this.dealService.dealInsuranceService.removeInsuranceProduct(this.product);
    this.closeModal.emit();
  }

  // UI CONTROL & RENDERING

  get termCosts(): TermCost[] {
    const terms = this.product ? this.product.termCosts : false;
    return terms || [];
  }

  planSelected(): boolean {
    const {termCostIndex} = this.gapForm.value;
    return this.selectedTermIndex === +termCostIndex;
  }

  noPlanSelected(): boolean {
    return this.selectedTermIndex === null;
  }

}
